import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, LogIn, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isActiveWorkflow } from "@/lib/activeWorkflowGuard";

export function SessionExpiredBanner() {
  const { sessionExpired, dismissExpiry } = useAuth();
  const navigate = useNavigate();

  // WORKFLOW GUARD: Never show "session expired" during active appraisal —
  // it's just the iOS WebView restarting after camera use, not a real expiry.
  if (!sessionExpired || isActiveWorkflow()) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-[100] bg-destructive/95 text-destructive-foreground rounded-lg shadow-lg p-4 flex items-start gap-3 animate-in slide-in-from-bottom-4 duration-300">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Session expired</p>
        <p className="text-xs opacity-90 mt-0.5">Please log in again to continue.</p>
        <Button
          size="sm"
          variant="secondary"
          className="mt-2 gap-1.5"
          onClick={() => {
            dismissExpiry();
            navigate("/auth");
          }}
        >
          <LogIn className="h-3.5 w-3.5" />
          Go to Login
        </Button>
      </div>
      <button
        onClick={dismissExpiry}
        className="shrink-0 opacity-70 hover:opacity-100 transition-opacity"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
